"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _helpersStylesIcons = require("./helpers-styles-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextSelectField = function (_React$Component) {
  (0, _inherits3.default)(TextSelectField, _React$Component);

  function TextSelectField(props) {
    (0, _classCallCheck3.default)(this, TextSelectField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TextSelectField.__proto__ || (0, _getPrototypeOf2.default)(TextSelectField)).call(this, props));

    _this.setFieldRef = function (node) {
      _this.fieldRef = node;
    };

    _this.setInputRef = function (node) {
      _this.inputRef = node;
    };

    _this.handleOutsideClick = function (ev) {
      if (_this.fieldRef && !_this.fieldRef.contains(ev.target)) {
        _this.updateInput();
        _this.hideOptions();
        _this.setState({ focusedOption: _this.initialFocusedOption });
      }
    };

    _this.handleInputChange = function (ev) {
      _this.setState({ inputValue: ev.target.value });

      if (!ev.target.value) {
        _this.props.onChange({ target: { value: "" } });
      }
    };

    _this.showOptions = function () {
      _this.setState({ isShowingOptions: true });
      if (_this.inputRef) _this.inputRef.focus();
    };

    _this.hideOptions = function () {
      _this.setState({ isShowingOptions: false });
      if (_this.inputRef) _this.inputRef.blur();
    };

    _this.selectOption = function (o) {
      if (o) {
        _this.props.onChange({ target: { value: o.value } });
        _this.handleInputChange({ target: { value: o.label } });
        _this.hideOptions();
      }
    };

    _this.updateInput = function () {
      if (_this.props.value && _this.props.options && _this.props.options.length) {
        var selectedOption = _this.props.options.find(function (o) {
          return o.value === _this.props.value;
        });
        _this.setState({ inputValue: selectedOption ? selectedOption.label : _this.props.value });
      }

      if (!_this.props.value) {
        _this.setState({ inputValue: "" });
      }
    };

    _this.filterOptionsAndConcatIfUnlistedAllowed = function () {
      var _this$props = _this.props,
          _this$props$options = _this$props.options,
          options = _this$props$options === undefined ? [] : _this$props$options,
          allowUnlisted = _this$props.allowUnlisted;
      var inputValue = _this.state.inputValue;

      var filteredOptions = options.filter(function (o) {
        return new RegExp(inputValue, "gi").test(o.label);
      });

      if (filteredOptions.length === 0 && allowUnlisted && inputValue.trim()) {
        return filteredOptions.concat({
          label: inputValue.trim(),
          value: inputValue.trim()
        });
      }

      return filteredOptions;
    };

    _this.handleInputKeyDown = function (ev) {
      switch (ev.key) {
        case "Enter":
          ev.preventDefault();
          ev.stopPropagation();
          _this.selectOption(_this.filterOptionsAndConcatIfUnlistedAllowed().find(function (o) {
            return o.value === _this.state.focusedOption.value;
          }));
          break;

        case "ArrowUp":
          ev.preventDefault();
          ev.stopPropagation();
          _this.setState(function (state) {
            return { focusedOption: (0, _helpersStylesIcons.focusOption)("prev")(state.focusedOption.index) };
          });
          break;

        case "ArrowDown":
          ev.preventDefault();
          ev.stopPropagation();
          _this.setState(function (state) {
            return { focusedOption: (0, _helpersStylesIcons.focusOption)("next")(state.focusedOption.index) };
          });
          break;

        case "Tab":
          ev.preventDefault();
          ev.stopPropagation();
          _this.updateInput();
          _this.hideOptions();
          break;

        default:
          break;
      }
    };

    _this.fieldRef = null;
    _this.inputRef = null;
    _this.initialFocusedOption = {
      index: -1,
      value: null,
      label: ""
    };
    _this.state = {
      inputValue: "",
      isShowingOptions: false,
      focusedOption: _this.initialFocusedOption
    };
    return _this;
  }

  (0, _createClass3.default)(TextSelectField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.handleOutsideClick);
      this.updateInput();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.updateInput();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          name = _props.name,
          value = _props.value,
          error = _props.error,
          disabled = _props.disabled,
          _props$isLoading = _props.isLoading,
          isLoading = _props$isLoading === undefined ? false : _props$isLoading,
          _props$maxHeight = _props.maxHeight,
          maxHeight = _props$maxHeight === undefined ? 240 : _props$maxHeight;
      var _state = this.state,
          inputValue = _state.inputValue,
          isShowingOptions = _state.isShowingOptions,
          focusedOption = _state.focusedOption;

      var options = this.filterOptionsAndConcatIfUnlistedAllowed();
      var isListOpen = isShowingOptions && options.length > 0;

      return _react2.default.createElement(
        "div",
        { className: _helpersStylesIcons.textSelectFieldStyles },
        _react2.default.createElement(
          "div",
          { className: "fieldContainer", ref: this.setFieldRef },
          _react2.default.createElement(
            "div",
            { className: "inputField" },
            label && _react2.default.createElement(
              "label",
              { htmlFor: name },
              label
            ),
            _react2.default.createElement(
              "div",
              {
                className: (0, _classnames2.default)({ inputContainer: true, hasError: Boolean(error) }),
                onClick: this.showOptions },
              _react2.default.createElement("input", {
                name: name,
                type: "text",
                ref: this.setInputRef,
                value: inputValue,
                disabled: disabled || isLoading,
                onChange: this.handleInputChange,
                onKeyDown: this.handleInputKeyDown,
                onFocus: this.showOptions
              }),
              _react2.default.createElement(
                "span",
                { className: "optionsIcon" },
                isLoading ? _react2.default.createElement(_Preloader2.default, null) : options.length > 0 ? _react2.default.createElement(_helpersStylesIcons.SelectFieldIcon, null) : null
              )
            )
          ),
          isListOpen && _react2.default.createElement(
            "div",
            { className: "optionsList", style: { maxHeight: maxHeight } },
            options.map(function (o, i) {
              var _classNames;

              return _react2.default.createElement(
                "div",
                {
                  key: o.value,
                  tabIndex: 1,
                  onClick: function onClick() {
                    return _this2.selectOption(o);
                  },
                  className: (0, _classnames2.default)((_classNames = {
                    optionItem: true
                  }, (0, _defineProperty3.default)(_classNames, _helpersStylesIcons.textSelectFieldItemHoveredStyles, i === focusedOption.index), (0, _defineProperty3.default)(_classNames, _helpersStylesIcons.textSelectFieldItemDisabledStyles, o.disabled), _classNames)) },
                _react2.default.createElement(
                  "option",
                  { disabled: o.disabled, value: o.value },
                  o.label
                ),
                o.value === value && _react2.default.createElement("img", { src: "/icons/tick.svg" })
              );
            })
          ),
          error && _react2.default.createElement(
            "div",
            { className: "fieldError" },
            error
          )
        )
      );
    }
  }]);
  return TextSelectField;
}(_react2.default.Component);

exports.default = TextSelectField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/TextSelectField.jsx
// module id = 2914
// module chunks = 0